module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "client",
    class: {
      print: _vm.printing
    }
  }, [(_vm.loaded && !_vm.printing) ? _c('dg-header') : _vm._e(), _vm._v(" "), (_vm.printing) ? _c('dg-print-header') : _vm._e(), _vm._v(" "), (_vm.loaded) ? _c('dg-calculator', {
    attrs: {
      "printing": _vm.printing,
      "companies": _vm.companies,
      "chosenCompanies": _vm.chosenCompanies,
      "type": _vm.type
    },
    on: {
      "updatePrice": _vm.updatePrice,
      "updateType": _vm.updateType,
      "handleCompany": _vm.handleCompany,
      "updateDiscount": _vm.updateDiscount,
      "handleOnlyThisCompany": _vm.handleOnlyThisCompany
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loaded && !_vm.printing) ? _c('dg-result', {
    attrs: {
      "companies": _vm.companies,
      "chosen": _vm.chosenCompanies,
      "type": _vm.type
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loaded) ? _c('dg-savings', {
    attrs: {
      "printing": _vm.printing,
      "companies": _vm.selectedCompanies,
      "type": _vm.type,
      "savings": _vm.savings
    },
    on: {
      "sendToPrinting": _vm.sendToPrinting,
      "updateSavings": _vm.updateSavings
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b0a4060","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/app.vue
// module id = 286
// module chunks = 1